import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function HotComics() {
  const hotComics = comics.filter((c) => c.isHot).slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-1">
              <i className="ri-fire-line text-accent-500 mr-2"></i>
              热门韩漫
            </h2>
            <p className="text-sm text-foreground-500">全网最受欢迎的韩漫作品</p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {hotComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.slug}`}
              className="group"
            >
              <div className="relative overflow-hidden rounded-lg mb-2 md:mb-3 aspect-[2/3]">
                <img
                  src={comic.coverImage}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
                <div className="absolute top-2 left-2">
                  <span className="inline-block px-2 py-0.5 rounded text-[10px] md:text-xs font-semibold bg-accent-500 text-background-50">
                    热门
                  </span>
                </div>
                {comic.status === 'completed' && (
                  <div className="absolute top-2 right-2">
                    <span className="inline-block px-2 py-0.5 rounded text-[10px] md:text-xs font-medium bg-background-50/90 text-foreground-700">
                      已完结
                    </span>
                  </div>
                )}
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span>{comic.author}</span>
                <span className="text-foreground-300">|</span>
                <span className="flex items-center gap-0.5">
                  <i className="ri-star-fill text-accent-500 text-[10px]"></i>
                  {comic.rating}
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}